export default "__VITE_ASSET__8lqY1lVW__"